<script>
    import {isActive} from '../routes';

    export let assessment_type_id;
</script>

<p class="panel-tabs">
    <a class:is-active={isActive(`#/assessmentTypes/${assessment_type_id}/info`)} href="#/assessmentTypes/{assessment_type_id}/info">Info</a>
    <a class:is-active={isActive(`#/assessmentTypes/${assessment_type_id}`)} href="#/assessmentTypes/{assessment_type_id}">Controls</a>
    <a class:is-active={isActive(`#/assessmentTypes/${assessment_type_id}/tags`)} href="#/assessmentTypes/{assessment_type_id}/tags">Tags</a>
    <!--<a class:is-active={isActive(`#/assessmentTypes/${assessment_type_id}/policies`)} href="#/assessmentTypes/{assessment_type_id}/policies">Policies</a>-->
    <a class:is-active={isActive(`#/assessmentTypes/${assessment_type_id}/Report`)} href="#/assessmentTypes/{assessment_type_id}/Report">Report</a>
</p>